import React from 'react';
import { useLocation } from 'react-router-dom';
import ComingSoonPage from '@/components/ComingSoonPage';

/**
 * Generic Coming Soon Page
 * Displays a placeholder page for any route that doesn't have an actual page yet
 * Content is dynamically generated based on the current route
 */
const GenericComingSoonPage: React.FC = () => {
  const location = useLocation();

  // Extract the feature name from the URL path
  const getFeatureName = (pathname: string): string => {
    const path = pathname.replace(/^\/+/, '').replace(/\/+$/, '');
    if (!path) return 'Home';

    // Special case for TTS
    if (path.toLowerCase() === 'tts') return 'TTS';

    // Convert kebab-case or snake_case to Title Case
    return path
      .split(/[-_]/)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  // Generate dynamic content based on the route
  const getDynamicContent = (pathname: string) => {
    const featureName = getFeatureName(pathname);

    const descriptionFeatureName =
      pathname === '/tts' ? 'TTS' : featureName.toLowerCase();

    // Generic content for all routes
    const content = {
      title: `${featureName} Coming Soon`,
      description: `The ${descriptionFeatureName} feature is currently under development. We're working hard to bring you an amazing experience.`,
      icon: '🚀',
    };

    return content;
  };

  const content = getDynamicContent(location.pathname);

  return (
    <ComingSoonPage
      title={content.title}
      description={content.description}
      icon={content.icon}
    />
  );
};

GenericComingSoonPage.displayName = 'GenericComingSoonPage';

export default GenericComingSoonPage;
